const doc = [({"en":({"js":({"admin":({"contacts":({"show":({"person":({"surveys_nav":({"teams":"Teams", "team_surveys":"Team surveys"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;